import type { FunctionComponent } from 'react';
import React from 'react';
import classNames from 'classnames';

import { forTemplate } from '@trello/i18n';
import { PowerUpTestIds } from '@trello/test-ids';
import {
  useWorkspaceNavigation,
  useWorkspaceNavigationHidden,
} from '@trello/workspace-navigation';

import styles from './Banner.less';

const format = forTemplate('directory');
interface BannerProps {
  readonly heading: string;
  readonly paragraph: string;
}

export const Banner: FunctionComponent<BannerProps> = ({
  heading,
  paragraph,
}) => {
  const [{ expanded: _workspaceNavigationExpanded }] = useWorkspaceNavigation();
  const [{ hidden: _workspaceNavigationHidden }] =
    useWorkspaceNavigationHidden();
  const workspaceNavigationExpanded =
    !_workspaceNavigationHidden && _workspaceNavigationExpanded;

  return (
    <div
      className={classNames(styles.directoryBannerContainer, {
        [styles.workspaceNavigationExpanded]: workspaceNavigationExpanded,
      })}
      data-testid={PowerUpTestIds.Banner}
    >
      <div
        className={classNames(styles.directoryBanner, {
          [styles.workspaceNavigationExpanded]: workspaceNavigationExpanded,
        })}
      >
        <div>
          <h1
            className={styles.bannerHeading}
            data-testid={PowerUpTestIds.BannerHeader}
          >
            {format(heading)}
          </h1>
          <p
            className={styles.bannerParagraph}
            data-testid={PowerUpTestIds.BannerParagraph}
          >
            {format(paragraph)}
          </p>
          <div />
        </div>
      </div>
    </div>
  );
};
